/** 繁體中文（獨立維護，非簡繁轉換） */
export default {
  lang_zh_hans: '简体中文',
  lang_zh_hant: '繁體中文',
  lang_en: 'English',
  lang_picker_title: '選擇語言',
  lang_switch: '語言切換',
  lang_current: '當前語言',

  common_back: '返回',
  common_cancel: '取消',
  common_ok: '確定',
  common_confirm: '確認',
  common_close: '關閉',
  common_query: '查詢',
  common_setting: '設置',
  common_save: '保存',
  common_submit: '提交',
  common_loading: '加載中...',
  common_empty: '空空如也',
  common_tip: '提示',
  common_yuan: '元',
  common_scan: '掃碼',
  common_scan_get: '掃碼獲取',
  common_scan_error: '掃碼異常',
  common_please_enter: '請輸入',
  common_exit_system: '退出系統?',
  common_retry: '重試',
  common_filter: '篩選',
  common_date: '日期',
  common_all: '所有',
  net_error_reconnect: '處理中{0}s',
  brand_hst: '惠商通',
  brand_epay: 'SPayPOS',
  brand_spay: 'SPayPOS',

  home_loading: '數據加載中...',
  home_query: '查詢',
  home_zbf: '桌邊付',
  home_setting: '設置',
  home_exit: '退出',
  home_set_outlet: '請設置營業點',
  home_discount_trade: '優惠交易',
  home_cashier: '收銀',
  home_refund: '退款',

  setting_title: '設置',
  setting_param: '參數設置',
  setting_maintenance: '維護手冊',
  setting_device_info: '設備信息',
  setting_logon: '簽到',
  setting_print_bill: '打印賬單',
  setting_upload: '日誌上送',
  setting_clear_cache: '清空緩存',
  setting_channel: '渠道設置',
  setting_discount: '優惠設置',
  setting_exit: '系統退出',
  setting_address: '地址設置',
  setting_ter_bind: '終端綁定',
  setting_lang: '語言切換',
  setting_settle: '結算',
  setting_update: '更新',
  tip_amount: '小費金額',
  print_bill_title: '打印賬單',
  print_bill_start: '開始時間',
  print_bill_end: '結束時間',
  print_bill_total: '打印匯總',
  print_bill_detail: '打印明細',
  print_bill_need_date: '請選擇開始和結束時間',
  print_bill_success: '打印成功',
  print_bill_fail: '打印失敗',

  password_title: '安全驗證',
  password_need_6: '密碼為 6 位數字',
  password_wrong: '密碼錯誤',

  ter_bind_title: '參數設置',
  ter_bind_trade_url: '交易地址',
  trade_url_pick: '選擇',
  trade_url_pick_title: '選擇交易地址',
  trade_url_env_prod: '生產環境',
  trade_url_env_uat: 'UAT 環境',
  trade_url_env_dev: '開發環境',
  trade_url_input_hint: '選擇、掃碼或手動輸入',
  ter_bind_platform: '平台號',
  ter_bind_outlet: '營業點',
  ter_bind_comm_mode: '通信模式',
  ter_bind_poll: '輪詢(穩定)',
  ter_bind_push: '推送(速度)',
  ter_bind_day_poll: '白天輪詢(秒)',
  ter_bind_night_poll: '夜間輪詢(秒)',
  ter_bind_push_url: '推送地址',
  ter_bind_more: '更多設置',
  ter_bind_zbf: '桌邊付',
  ter_bind_auto_submit: '自動提交',
  ter_bind_throttle: '節流模式',
  ter_bind_once: '單次交互',
  ter_bind_self_cashier: '自主收銀',
  ter_bind_mask: '啟用遮罩',
  ter_bind_pre_upload: '預上送',
  ter_bind_auth_complete_print: '預授權完成是否打印',
  ter_bind_add_auth_print: '預授權追加是否打印',
  ter_bind_wait_time: '倒計時(秒)',
  ter_bind_reprint_num: '打印聯數',
  ter_bind_remark_space: '備註空格',
  ter_bind_auth_pwd: '權限密碼',
  ter_bind_discount_url: '優惠地址',
  ter_bind_remark_space_ph: '備註空格行數',
  ter_bind_auth_pwd_ph: '退款、撤銷時權限密碼,6位純數字',
  ter_bind_open_hidden: '打開隱藏參數',
  ter_bind_close_hidden: '關閉隱藏參數',
  ter_bind_save_ok: '保存成功',

  ter_info_title: '設備信息',
  ter_info_version: '軟件版本：',
  ter_info_vendor: '設備廠商：',
  ter_info_sn: '硬件序列號：',
  ter_info_model: '設備機型：',
  ter_info_os: 'OS版本：',
  ter_info_net: '網絡類型：',
  ter_info_wifi: 'wifi',
  ter_info_mobile: '移動',
  ter_info_desktop: '智能桌面版本：',
  ter_info_lng: '經度：',
  ter_info_lat: '緯度：',
  ter_info_city_code: '城市碼：',
  ter_info_city_name: '城市名稱：',
  ter_info_address: '地址：',

  upload_title: '日誌上送',
  upload_pick_day: '請選擇一天',
  upload_btn: '上送日誌',
  upload_log: '日誌',
  upload_data: '數據',
  upload_need_date: '請選擇日期',
  upload_need_type: '至少選擇一個文件類型',
  upload_fail: '上傳失敗,聯繫技術人員',

  delcache_title: '清空緩存',
  delcache_btn: '清除緩存',
  delcache_clear: '清除',
  delcache_confirm: '即將清除半年前的記錄?',

  seturl_title: '設置',
  seturl_address: '通訊地址',
  seturl_scanable: '可掃碼',
  seturl_success: '設置成功',

  channel_title: '渠道設置',
  channel_success: '設置成功',

  discount_bind_title: '終端綁定',
  discount_id_code: '身份碼',
  discount_scan_qr: '請掃碼二維碼獲取',
  discount_term_code: '終端碼',
  discount_mch_name: '商戶名稱',
  discount_mch_no: '商戶號',
  discount_term_name: '終端名稱',
  discount_org_id: '組織ID',
  discount_inst_id: '機構ID',
  discount_term_id: '終端ID',
  discount_bound: '已綁定',
  discount_bind: '綁定',

  maintenance_title: '維護手冊',
  push_title: '推送設置',
  push_bank_void: '是否支持銀行卡當日撤銷',

  poll_retry: '重試',
  poll_check_config: '檢查配置',
  poll_net_retry: '網絡異常 {0} 後重連',

  cashier_title: '快速收銀',
  cashier_bank: '銀行卡',
  cashier_qr: '二維碼',
  cashier_switch: '(點擊切換)',
  cashier_need_expr: '請輸入算式',
  cashier_need_equal: '請先按等於號計算',
  cashier_need_amount: '請輸入金額',
  cashier_pay: '收款',
  cashier_done: '完成',
  cashier_union_qr: '銀聯二維碼',
  cashier_wechat: '微信',
  cashier_alipay: '支付寶',
  cashier_other: '其他',

  query_title: '查詢',
  query_trade_detail: '交易明細',
  query_unknown: '未知交易',
  query_icbc: '工銀收單明細',
  query_discount: '優惠明細',
  query_act: '活動查詢',
  query_luckdraw: '中獎查詢',
  query_bank_flow: '銀行流水',
  query_bank_unknown: '查詢銀行卡未知交易',
  query_qr_unknown: '查詢二維碼未知交易',
  query_mch_discount: '查詢商戶優惠信息',
  query_notify_exc: '異常推送',
  query_notify_exc_mis: '異常上送',

  trade_type: '交易類型',
  trade_type_colon: '交易類型：',
  trade_ref_no: '檢索參考號',
  trade_ref_no_colon: '檢索參考號:',
  trade_ref_no_origin: '原交易的檢索參考號',
  trade_amount: '交易金額',
  trade_amount_colon: '交易金額：',
  trade_order_no: '商戶訂單號',
  trade_order_no_colon: '商戶訂單號:',
  trade_order_no_local: '本機訂單號',
  trade_order_no_ph: '請輸入商戶訂單號',
  trade_time: '交易時間',
  trade_time_colon: '交易時間:',
  trade_card: '交易卡號',
  trade_card_colon: '交易卡號:',
  trade_card_no: '卡號',
  trade_card_ph: '請輸入卡號',
  trade_get_card: '獲取卡號',
  trade_read_card: '讀卡',
  trade_read_card_hint: '刷卡/插卡/手輸',
  trade_success: '交易成功',
  trade_fail: '交易失敗',
  trade_unknown: '未知',
  trade_upload_ok: '上送成功',
  trade_upload_fail: '上送失敗',
  trade_bank: '銀行卡',
  trade_qr: '二維碼',
  trade_print: '打印憑證',
  trade_reprint: '補打憑證',
  trade_reupload: '重新上送',
  trade_refund: '退款',
  trade_refunded: '已退',
  trade_upload_fail_tab: '上送失敗',
  trade_unknown_tab: '未知交易',
  trade_refund_amount: '退款金額',
  trade_refund_amount_ph: '請輸入退款金額,單位元',
  trade_need_refund_amount: '請輸入退款金額',
  trade_need_scan_qr: '請掃二維碼',
  trade_submit_ok: '提交成功',
  trade_txn_01: '消費',
  trade_txn_02: '消費撤銷',
  trade_txn_03: '退貨',
  trade_txn_05: '預授權',
  trade_txn_07: '預授權撤銷',
  trade_txn_09: '預授權完成',
  trade_txn_11: '預授權完成撤銷',
  trade_pick_date: '選擇日期',
  trade_unclear: '不明確',
  trade_ok: '成功',
  trade_fail_short: '失敗',
  trade_order_time: '訂單時間:',
  trade_sync: '同步交易',
  trade_upload_fail_msg: '交易上傳失敗',
  trade_reupload_ask: '是否重新上傳?',
  trade_one_key_upload: '一鍵上送',
  trade_resend: '重新發送',
  trade_uploading: '上送中',
  trade_method: '交易方式',
  trade_mch_order: '商戶訂單',
  trade_order_time_label: '訂單時間',
  trade_order_amount: '訂單金額',
  trade_real_amount: '實際交易金額',
  trade_mch_remark: '商戶備註',
  trade_op_remark: '操作備註',
  trade_print_info: '打印信息',
  trade_discount_query: '優惠查詢',
  trade_submit_order: '提交訂單',
  trade_discount_info: '優惠信息',
  trade_refund_break: '退款中斷',
  trade_abort_ask: '確認中止訂單?',
  trade_suspend_ask: '是否掛起訂單，可通過補單繼續交易?',
  trade_title: '交易',
  trade_reprint_title: '重打印',
  trade_pay_way: '支付方式',
  trade_detail: '詳情',
  trade_acquirer: '收單行',
  trade_paid_amount: '實付金額',
  trade_discount_amount: '優惠金額',
  trade_discount_channel: '優惠通道',
  trade_act_name: '活動名稱',
  trade_refund_status: '退款情況',
  trade_refund_partial: '部分退款',
  trade_refund_full: '全部退款',
  trade_refund_times: '退款次數',
  trade_refund_total: '退款總額',
  trade_void_today: '當日撤銷',
  trade_refund_txn: '交易退款',
  trade_unknown_query: '未知查詢',
  trade_waiting: '等待',
  trade_fail_status: '失敗',
  trade_ok_status: '成功',
  trade_process_ok: '處理成功',
  trade_repush: '補單',

  act_title: '優惠活動',
  act_ongoing: '進行中',
  act_history: '未開始/歷史',
  act_not_start: '未開始',
  act_minus: '減',
  act_discount: '折',
  act_cap: '封頂',
  act_start: '開始時間：',
  act_end: '結束時間：',

  discashier_title: '優惠交易',
  discashier_amount: '金額',
  discashier_amount_ph: '請輸入支付金額',
  discashier_amount_error: '輸入金額有誤',

  refund_title: '退款',
  refund_void_today: '當日撤銷',
  refund_dis: '優惠退貨',
  refund_next_day: '隔日退貨',
  refund_qr: '二維碼退款',
  refund_dis_title: '優惠退款',
  refund_act_order: '活動訂單號',
  refund_act_order_origin: '原交易活動訂單號',
  refund_next_day_title: '隔日退款',
  refund_qr_order: '訂單號',
  refund_qr_order_origin: '原交易二維碼訂單號',
  refund_need_ref: '請輸入原交易的檢索參考號',

  authority_title: '交易開關控制',
  authority_bank_void: '是否支持銀行卡當日撤銷',
  authority_bank_refund: '是否支持銀行卡隔日退貨',
  authority_bank_pre_void: '是否支持銀行卡預授權撤銷',
  authority_bank_pre_confirm_void: '是否支持銀行卡預授權確認撤銷',
  authority_bank_pre_confirm_refund: '是否支持銀行卡預授權確認隔日退貨',
  authority_qr_void: '是否支持掃碼當日撤銷',
  authority_qr_refund: '是否支持掃碼隔日退貨',

  luck_title: '中獎查詢',
  luck_act_order: '活動訂單',
  luck_act_order_ph: '原優惠交易的活動訂單',
  luck_need_act_order: '請填寫活動訂單號',
  luck_discount_info: '優惠信息',
  luck_draw_info: '抽獎信息',
  luck_order_status: '訂單狀態',
  luck_level: '中獎級別',
  luck_prize: '獎品',
  luck_remark: '備註',
  luck_status: '狀態',
  luck_pre_deduct_ok: '優惠預扣成功',
  luck_not_won: '未中獎',
  luck_claimed: '已領獎',
  luck_unclaimed: '未領獎',
  luck_returned: '已退貨',
  luck_registered: '已登記',
  trade_voided: '已撤銷',

  bank_flow_title: '銀行流水',
  bank_term_seq: '終端流水號',
  bank_ref_origin: '原交易檢索參考號',
  bank_start: '開始時間',
  bank_end: '結束時間',
  bank_time_desc: '按時間倒序',
  bank_error: '程序錯誤,聯繫技術人員',

  qr_query_title: '二維碼查詢',
  qr_order_no: '訂單號',
  qr_order_origin: '原交易的二維碼訂單號',
  qr_need_order: '請填寫訂單號',
  qr_synced: '本地已同步',

  quick_cashier_title: '快速收銀',
  quick_cashier_no: '單號:',

  connect_reconnect: '立即重連',
  connect_retry_ss: '連接中斷 {0} 後重連',
  connect_fail_ss: '連接失敗 {0} 後重連',
  connect_fail: '連接失敗',
  connect_ok: '連接成功',

  discount_act_colon: '優惠活動:',
  discount_order_colon: '優惠訂單號:',
  discount_order_local: '本機/優惠訂單號'
}



// WEBPACK FOOTER //
// ./src/locale/zh-Hant.js